const searchAttributes = ['subject', 'label'] as const;
const listAttributes = [
  'subject',
  'examId',
  'label',
  'shortLabel',
  'maxMark',
  'analytics',
  'type',
  'active',
] as const;
const getAttributes = [...listAttributes, 'creationDatetime', 'editDatetime', 'topics'] as const;
const updateAttributes = [
  'label',
  'shortLabel',
  'type',
  'editDatetime',
  'active',
  'maxMark',
] as const;

export const LegacyExamAttributes = {
  Search: searchAttributes,
  List: listAttributes,
  Get: getAttributes,
  Update: updateAttributes,
};
